import daryaSticker from './assets/darya_sticker.png';
import vanyaSticker from './assets/vanya_sticker.png';
import yuliaSticker from './assets/yulia_sticker.png';
import artemSticker from './assets/artem_sticker.png';
import cherny_stiker from './assets/cherny_stiker.png';
import dima_stiker from './assets/dima_sticker.png';
import anton_stiker from './assets/anton_stiker.png';
import stepa_stiker from './assets/stepa_stiker.png';
import dima_kol_stiker from './assets/dimakol_stiker.png';
import yru_stiker from './assets/yru_stiker.png';
import alexandra_stiker from './assets/alexandra_stiker.png';
import lisa_stiker from './assets/lisa_stiker.png';
import yuri_stiker from './assets/yuri.jpg';

export const congratulations = [

  {
    id: 1,
    personName: "Ваня",
    voiceMessage: "audio/Vanya_greeting.mp3",
    sticker: vanyaSticker,
    quote: "Мог ухлестовать за твоими пьяными подружками, а вместо этого топчу наряд",
  },
  {
    id: 2,
    personName: "Юлия",
    voiceMessage: "audio/Yulia_greeting.mp3",
    sticker: yuliaSticker,
    quote: "Саня, с днюхой! Говорят, в Геленджике можно встретить свою судьбу… Я пока встретила только продавца чурчхелы. Жду встречи, как Хатико!",
  },
  {
    id: 3,
    personName: "Артём",
    voiceMessage: "audio/Artem_greeting.mp3",
    sticker: artemSticker,
    quote: "Если жизнь — это марш-бросок, то ты — наш командир в тапочках",
  },
      {
    id: 4,
    personName: "Степа",
    voiceMessage: "audio/stepa_greeting.mp3",
    sticker: stepa_stiker,
    quote: "Пусть твоя жизнь будет как сериал без рекламы!",
  },
  {
    id: 5,
    personName: "Черный",
    voiceMessage: "audio/Cherny_greeting.mp3",
    sticker: cherny_stiker,
    quote: "Я не пародирую Ельцина, меня просто изменила армия",
  },
  {
    id: 6,
    personName: "Дмитрий",
    voiceMessage: "audio/Dmitry_greeting.mp3",
    sticker: dima_stiker,
    quote: "Телепатически передаю тебе энергию счастья и позитива на целый год",
  },
  {
    id: 7,
    personName: "Антон",
    voiceMessage: "audio/Cherny_greeting.mp3",
    sticker: anton_stiker,
    quote: "Ты лучшая, даже если ешь суши палками от барабана.",
  },
    {
    id: 8,
    personName: "Дмитрий Колесникович",
    voiceMessage: "audio/DmityKol.mp3",
    sticker: dima_kol_stiker,
    quote: "Александра! Пусть твой успех будет высоким, как твои амбиции, а эмоции такими — яркими, как мои выходки после третьей рюмки",
  },
      {
    id: 9,
    personName: "Юрец огурец",
    voiceMessage: "audio/Dahya_greeting.mp3",
    sticker: yuri_stiker,
    quote: "Сашенька, поздравляю тебя с днем рождения! Желаю тебе всего самого лучшего!",
  },
    {
    id: 10,
    personName: "Юра",
    voiceMessage: "audio/Dahya_greeting.mp3",
    sticker: yru_stiker,
    quote: "Саш, главное — не считай годы, считай поводы для праздника! А они у тебя есть КАЖДЫЙ день!",
  },
    {
    id: 11,
    personName: "Александра",
    voiceMessage: "audio/Dahya_greeting.mp3",
    sticker: alexandra_stiker,
    quote: "Ты как мое отражение в зеркале — всегда прекрасна",
  },
    {
    id: 12,
    personName: "Лиза",
    voiceMessage: "audio/Dahya_greeting.mp3",
    sticker: lisa_stiker,
    quote: "В списке чудес света теперь 8 пунктов. Ты — восьмое.",
  },
    {
    id: 13,
    personName: "Даша",
    voiceMessage: "audio/Dahya_greeting.mp3",
    sticker: daryaSticker,
    quote: "Желаю, чтобы твои слёзы были только от лука, а икота — от смеха",
  },





];